import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container/src/index.tsx';
import { ErrorBoundaryWithChunkErrorLogging } from '@atlassian/jira-onboarding-core/src/ui/error-boundary-with-chunk-error-logging/index.tsx';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';
import { NthUserWelcomeModalEntryPoint } from '../entrypoint.tsx';
import { useCanShowNthUserWelcomeModal } from './useCanShowNthUserWelcomeModal.tsx';
import { NTH_USER_WELCOME_MODAL_SOURCE_NAME } from './types.tsx';

const entryPointParams = {};

type DispatchProps = {
	onShowUnassignedWorkItems?: () => void;
};

const NthUserWelcomeModalEntryPointWrapperInner = (props: DispatchProps) => {
	const canShowNthUserWelcomeModal = useCanShowNthUserWelcomeModal();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		NthUserWelcomeModalEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (canShowNthUserWelcomeModal) {
			entryPointActions.load();
		}
	}, [entryPointActions, canShowNthUserWelcomeModal]);

	return (
		<ModalEntryPointContainer
			id="nthUserWelcomeModalEntryPoint"
			entryPointReferenceSubject={entryPointReferenceSubject}
			packageName="jiraSoftwareOnboardingModals"
			entryPointActions={entryPointActions}
			teamName="jira-warepil"
			runtimeProps={props}
		/>
	);
};

export const NthUserWelcomeModalEntryPointWrapper = (props: DispatchProps) => {
	return (
		<ErrorBoundaryWithChunkErrorLogging
			id="nthUserWelcomeModalEntryPointWrapper"
			fallback="unmount"
			packageName="jiraSoftwareOnboardingModals"
			teamName="jira-warepil"
		>
			<ContextualAnalyticsData sourceName={NTH_USER_WELCOME_MODAL_SOURCE_NAME} sourceType={MODAL}>
				<NthUserWelcomeModalEntryPointWrapperInner {...props} />
			</ContextualAnalyticsData>
		</ErrorBoundaryWithChunkErrorLogging>
	);
};
